import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Create_new_task() {
    const [listProjectArray, setListProjectArray] = useState([]);
    const [listTaskMembersArray, setListTaskMembersArray] = useState([]);
    const [listSelectedMember, setListSelectedMember] = useState([]);
    const [linkedProjectID, setLinkedProjectId] = useState('')
    const [sidebarOpen, setSidebarOpen] = useState(false);
    let selectdprojectname = '';
    var selectedteamMemCount = 0;
    const navigate = useNavigate();
    useEffect(() => {
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        }
        console.log(obj)
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });

    }, []);

    const selectProjectId = (e) => {
        var trgval = e.target.value;
        selectdprojectname = listProjectArray.find(p => p.primary_key == trgval);
        // localStorage.getItem('selected_project_name',selectdprojectname);
        getMemListFortsk(trgval)
    }

    function getMemListFortsk(id) {
        localStorage.setItem('selected_project_id', id);
        setListTaskMembersArray([]);
        setListSelectedMember([]);
        var obj = {
            pro_id: id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjectMember.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                if (res !== 'fail' && res !== '') {
                    try {
                        var tskarr = res;
                        // ensure it's an array
                        if (Array.isArray(tskarr)) {
                            var len = tskarr.length;
                            if (len < 1) {
                                $('#promem').css('display', 'block');
                                $('#no_member_notoce').text('You have not create team for this project. Go to the member area and create a team.')
                            } else {
                                setListTaskMembersArray(tskarr);
                            }
                        } else {
                            // if memarr is null or not an array
                            setListTaskMembersArray([]);
                        }

                    } catch (e) {
                        console.error("Invalid JSON from backend:", e);
                        $('#memnum').text('0');
                        setListTaskMembersArray([]);
                    }
                } else {
                    showAlert('Cannot found any member for this project.');
                    setListTaskMembersArray([]);
                }
            },
        });
    }

    function selectTheMem(ind) {
        var trgid = 'mem' + ind;
        $('#' + trgid + ' .member_list_button').addClass('activeBtn');
        var memberid = listTaskMembersArray[ind].memberid;
        var com_id = listTaskMembersArray[ind].mem_com_id;
        var pro_id = listTaskMembersArray[ind].proid;
        var proname = listTaskMembersArray[ind].proname;
        var member_name = listTaskMembersArray[ind].membername;
        var status_member = listTaskMembersArray[ind].status_member;

        var obj = {
            id: ind,
            memberid: memberid,
            com_id: com_id,
            pro_id: pro_id,
            proname: proname,
            member_name: member_name,
            status_member: status_member
        }
        setListSelectedMember(prevArray => [...prevArray, obj]);
    }

    function removeMem(ind) {
        var trgid = 'mem' + ind;
        $('#' + trgid + ' .member_list_button').removeClass('activeBtn')
        setListSelectedMember(prevArray =>
            prevArray.filter(member => member.id !== ind)
        );
    }

    function saveTask() {
        var tskmember_arr = listSelectedMember;
        var leng = tskmember_arr.length;
        var project_id = localStorage.getItem('selected_project_id');
        if (project_id == '') {
            showAlert('Please select a project first')
        } else if (leng < 1) {
            showAlert('Please select at-leastg one member to work on this task')
        } else {

            var timehr = $('#tsk_time_hour').val() || '0';
            var timemn = $('#tsk_time_min').val() || '00';
            var fulltime = timehr + ':' + timemn;
            var tsx_desc = $('#tsx_desc').val();
            if (fulltime == '0:00') {
                showAlert('Please select the time to complete the task')
            } else if (tsx_desc == '') {
                showAlert("Please insert the task details.")
            } else {

                var project_name = selectdprojectname;
                var tsx_name = $('#tsx_name').val() || 'No Name Provided';
                var files = $('#comm_file')[0].files; // array of selected files
                var tsk_assign_by = localStorage.getItem('membername');
                var tsk_assign_id = localStorage.getItem('member_id');
                var com_id = localStorage.getItem('mem_company_id');

                $('.loader_inner').css('display', 'block')
                let formData = new FormData();

                formData.append('proid', project_id);
                formData.append('proname', project_name);
                formData.append('tsx_name', tsx_name);
                formData.append('tsx_desc', tsx_desc);
                formData.append('txn_id', generateId());
                formData.append('tsk_status', 'pending');
                formData.append('tsk_assign_by', tsk_assign_by);
                formData.append('tsk_assign_id', tsk_assign_id);
                formData.append('assignDate', getCurrentDateMMDDYYYY());
                formData.append('assign_time', fulltime);
                formData.append('Company_id', com_id);

                // Attach files
                for (let i = 0; i < files.length; i++) {
                    formData.append('attachments[]', files[i]);
                }

                fetch('save_the_task.php', {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.text()) // because PHP returns fk_id (text/number)
                    .then(result => {
                        console.log(result);

                        if (result !== 'fail' && result !== '') {
                            saveSelectedNames(result, tsx_name, tsx_desc);
                        } else {
                            // Reset UI (same as your AJAX error handling)
                            document.getElementById('tsk_time_hour').value = '';
                            document.getElementById('tsk_time_min').value = '';

                            localStorage.setItem('selected_project_id', 'n/a');
                            selectdprojectname = '';

                            document.getElementById('tsx_name').value = '';
                            document.getElementById('tsx_desc').value = '';

                            setListTaskMembersArray([]);
                            document.getElementById('selectpro').value = '';

                            showAlert("Cannot save task. Try later sometime");
                        }
                    })
                    .catch(error => {
                        console.error("Fetch Error:", error);

                        // Same error fallback
                        document.getElementById('tsk_time_hour').value = '';
                        document.getElementById('tsk_time_min').value = '';

                        localStorage.setItem('selected_project_id', 'n/a');
                        selectdprojectname = '';

                        document.getElementById('tsx_name').value = '';
                        document.getElementById('tsx_desc').value = '';

                        setListTaskMembersArray([]);
                        document.getElementById('selectpro').value = '';

                        showAlert("Cannot save task. Try again later");
                    });
            }
        }

    }

    function getCurrentDateMMDDYYYY() {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();

        return `${mm}-${dd}-${yyyy}`;
    }

    function saveSelectedNames(res, tsx_name, tsx_desc) {
        var tsk_assign_id = localStorage.getItem('member_id');
        var tskmember_arr = listSelectedMember;
        var tskcm = $('#tsx_name').val();
        var tskid = res.replace(/\D/g, ''); // Keeps only digits;
        let shortText = tsx_desc.slice(0, 120);
        var leng = tskmember_arr.length;
        if (selectedteamMemCount < leng) {
            var obj = {
                id: tskmember_arr[selectedteamMemCount].ind,
                memberid: tskmember_arr[selectedteamMemCount].memberid,
                com_id: tskmember_arr[selectedteamMemCount].com_id,
                pro_id: tskmember_arr[selectedteamMemCount].pro_id,
                proname: tskmember_arr[selectedteamMemCount].proname,
                member_name: tskmember_arr[selectedteamMemCount].member_name,
                status_member: tskmember_arr[selectedteamMemCount].status_member,
                tsk_id: tskid,
                tsk_name: tsx_name,
                tsx_desc: tsx_desc,
                assignById: tsk_assign_id
            }
            $.ajax({
                url: 'save_tsk_member.php',
                type: 'POST',
                data: obj,
                success: function (response) {
                    if (response != 'fail') {
                        repeat_the_same(res, tsx_name, tsx_desc);
                    } else {
                        $('.loader_inner').css('display', 'none')
                        $('#tsk_time_hour').val('');
                        $('#tsk_time_min').val('');
                        localStorage.setItem('selected_project_id', 'n/a');
                        selectdprojectname = ''
                        $('#tsx_name').val('')
                        $('#tsx_desc').val('')
                        setListTaskMembersArray([]);
                        $('#selectpro').val('');
                        showAlert("Cannot save task as one of your member history cannot save")
                    }

                }
            });
        } else {
            sendNotifications('task', tskid, tsx_name)

        }
    }

    function sendNotifications(type, task_id, purpose_name) {
        var company_id = localStorage.getItem('mem_company_id');
        var uniqueid = crypto.randomUUID();
        var creator_id = localStorage.getItem('member_id');
        var obj = {
            company_id: company_id,
            ref_id: task_id,
            type: 'task',
            creator_name: localStorage.getItem('membername'),
            purpose: 'New task',
            purpose_name: purpose_name,
            project_id: 0,
            task_id: task_id,
            goal_id: task_id,
            project_name: selectdprojectname,
            task_name: purpose_name,
            unid: uniqueid,
            creator_id: creator_id
        }
        $.ajax({
            type: 'POST',
            url: 'add_notifications.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result)
                $('.loader_inner').css('display', 'none')
                $('#tsk_time_hour').val('');
                $('#tsk_time_min').val('');
                localStorage.setItem('selected_project_id', 'n/a');
                selectdprojectname = ''
                $('#tsx_name').val('')
                $('#tsx_desc').val('')
                setListTaskMembersArray([]);
                $('#selectpro').val('');

                showAlert("Task saved successfully. You can now add another task");
                setTimeout(reloadThisPage, 1500);
            },
        });
    }

    function reloadThisPage() {
        navigate('/reload_create_task');
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }





    function repeat_the_same(res, tsx_name, tsx_desc) {
        selectedteamMemCount++;
        saveSelectedNames(res, tsx_name, tsx_desc);
    }


    function generateId() {
        return 'id-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
    }

    function returntoList() {
        navigate('/admin_mytask');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Add New Task</h2>
                    <button className='pull_right backtask_btn' onClick={returntoList}>Back to Tasklist</button>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_dsh_one_full mt-30'>

                    </div>
                    <div className='vl_dsh_one_full'>
                        <div className='vl_dsh_one_half'>
                            <p>Select a project from the dropdown below</p>
                            <div className='element_case'>
                                <label>Select Project</label>
                                <select className="border p-2 rounded" id="selectpro" onChange={selectProjectId}>
                                    <option value="">Select a Project</option>
                                    {listProjectArray.map((project) => (
                                        <option key={project.primary_key} value={project.primary_key}>
                                            {project.pro_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className='form_row'>
                                <p className='captiontext'>Assign to : -</p>
                                <div className='mem_list_area' id="promem">
                                    <h3 id="no_member_notoce"></h3>
                                    {listTaskMembersArray.map((item, index) => (

                                        <div className='vl_listing_button_cell' id={`mem${index}`}>
                                            <button className='member_list_button' onClick={() => { selectTheMem(index) }}>{item.membername}</button>
                                            <i className='ri-delete-bin-3-fill removeico' onClick={() => { removeMem(index) }}></i>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                        <div className='vl_dsh_one_half'>
                            <div className='form_block'>
                                <h3>{selectdprojectname}</h3>
                                <div className='form_row'>
                                    <label>Heading</label>
                                    <input type="text" id="tsx_name" placeholer="Enter Name" />
                                </div>
                                <div className='form_row'>
                                    <label>Description</label>
                                    <textarea id="tsx_desc"></textarea>
                                </div>
                                <div className='form_row'>
                                    <label>Upload Files</label>
                                    <input type="file" id="comm_file" multiple />
                                </div>
                                <div className='form_row'>
                                    <label>Time Line</label>
                                    <div className='timeblock'>
                                        <p>Hour</p>
                                        <input type="number" id="tsk_time_hour" placeholer="Hours" />
                                    </div>
                                    <div className='timeblock'>
                                        <p>Minutes</p>
                                        <input type="number" id="tsk_time_min" placeholer="Hours" />
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='vl_dsh_one_full'>
                        <div className='btn_holder text_right'>
                            <button className='save_btn' onClick={saveTask}>Save</button>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            <div className='loader_inner'>
                <p>Saving your date....please wait</p>
            </div>

        </div>
    )
}
